import React from 'react'
import QualificationComp from '../../Components/Qualification/QualificationComp'



function  Qualification() {
    return <>
       < QualificationComp />
    </>
}

export default  Qualification